<template>
  <div class="user-center-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.user_center') }}</span>
    </div>
    <div class="page-title hide-on-pad">{{ $t('user_center.title') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu/>
      </div>
      <div class="page-right ">

        <div class="welcome-info hide-on-pad-flex">
          <span v-t="{ path: 'user_center.welcome', args: { username } }"></span>
          <span class="level-text">{{ expRange[level-1].title }}{{ $t('user_center.level_span_label') }}</span>
        </div>

        <div class="level-info hide-on-pad">
          <div class="level-icons">
            <div class="level-icon" :class="{ active: level==1}">
              <div class="active-text">{{ $t('user_center.now_level') }}</div>
              <div class="icon-img level1"></div>
              <div class="next-level-notice">{{ getLevelNotice }}</div>
            </div>
            <div class="level-icon" :class="{ active: level==2}">
              <div class="active-text">{{ $t('user_center.now_level') }}</div>
              <div class="icon-img level2"></div>
              <div class="next-level-notice">{{ getLevelNotice }}</div>
            </div>
            <div class="level-icon" :class="{ active: level==3}">
              <div class="active-text">{{ $t('user_center.now_level') }}</div>
              <div class="icon-img level3"></div>
              <div class="next-level-notice">{{ getLevelNotice }}</div>
            </div>
            <div class="level-icon" :class="{ active: level==4}">
              <div class="active-text">{{ $t('user_center.now_level') }}</div>
              <div class="icon-img level4"></div>
              <div class="next-level-notice">{{ getLevelNotice }}</div>
            </div>
            <div class="level-icon" :class="{ active: level==5}">
              <div class="active-text">{{ $t('user_center.now_level') }}</div>
              <div class="icon-img level5"></div>
              <div class="next-level-notice">{{ getLevelNotice }}</div>
            </div>
          </div>
          <div class="level-exp">
              <div class="circle" :class="{ active: exp>=0 }"><span class="level-text">0</span></div>
              <div class="circle" :class="{ active: exp>=10000 }"><span class="level-text">10,000</span></div>
              <div class="circle" :class="{ active: exp>=20000 }"><span class="level-text">20,000</span></div>
              <div class="circle" :class="{ active: exp>=30000 }"><span class="level-text">30,000</span></div>
              <div class="circle" :class="{ active: exp>=40000 }"><span class="level-text">40,000</span></div>
              <div class="circle" :class="{ active: exp>=50000 }"><span class="level-text">50,000</span></div>
              <div class="line1"></div>
              <div class="line2">
              <div class="line-content" :style="{ transform: `scaleX(${exp/expTotal})` }"></div>
                <div class="cloud-block" :style="{ left: `${exp/expTotal*100}%` }">
                  <div class="cloud-text" v-t="{ path: 'user_center.collect_total', args: { exp } }"></div>
                  <Icon type="cloud" class="cloud-icon"/>
                </div>
              </div>
          </div>
        </div>

        <div class="level-info-mobile show-on-pad-flex">
          <div :class="`level-icon level${level}`"></div>
          <p class="user-name"><span class="big">{{ username }}</span>{{ $t('user_center.appellation') }}</p>
          <div class="level-text"><Icon type="crown"/>银级会员</div>
          <div class="level-exp-mobile">
            <div class="circle active"></div>
            <div class="line">
              <div class="line-schedule">
                <div class="cloud-block" :style="{ left: `${exp/expTotal*100}%` }">
                  <div class="cloud-text" v-t="{ path: 'user_center.collect_total', args: { exp } }"></div>
                  <Icon type="cloud" class="cloud-icon"/>
                </div>
                <div class="schedule-content" :style="{ transform: `scaleX(${getMobileExp})` }"></div>
              </div>
            </div>
            <div class="circle"><div class="circle-text">{{ $t('user_center.next_level') }}</div></div>
          </div>
        </div>

        <div class="page-link">
          <div class="link-item" v-for="(item,index) in pageItem" :key="index+'_link_item'" @click="$router.push({ name: item.linkName })">
            <Icon :type="item.icon"  :style="{ background: item.color }"  @clickevent="$router.push({ name: item.linkName })"/>
            <p class="title">{{ item.title }}</p>
            <p class="text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu';
import { get } from '../../utils/localStorage';

  export default {
    name: 'user-center',
    data() {
      return {
        username:'',
        level: 0,
        pageItem: this.$t('user_center.page_item'),
        exp: 12500,
        expTotal: 50000,
        expRange: [{start:0,end:10000,title:this.$t('user_center.level1')},{start:10000,end:20000,title:this.$t('user_center.level2')},{start:20000,end:30000,title:this.$t('user_center.level3')},{start:30000,end:40000,title:this.$t('user_center.level4')},{start:40000,end:50000,title:this.$t('user_center.level5')}]
      }
    },
    components: {
      userSideMenu
    },
    created() {
      // let pageLink = [];
      // pageLink.push({icon: 'user',title: '变更会员资讯',text: '您可以在这里更改会员资料', linkName: 'editInfo', color: '#FF3B30'});
      // pageLink.push({icon: 'lock',title: '变更密码',text: '您可以在这里更改密码', linkName: 'changePwd', color: '#5AC8FA'});
      // pageLink.push({icon: 'chart',title: '預約記錄',text: '您可以在这里查看您的預約记录', linkName: 'customReserveOrder', color: '#bbbbbb'});
      // pageLink.push({icon: 'board',title: '历史订单',text: '您可以查看过去购买的商品清单', linkName: 'order', color: '#5856D6'});
      // pageLink.push({icon: 'custom',title: '订制商品订单',text: '您可以查看过去购买的订制商品清单', linkName: 'customOrder', color: '#FF9500'});
      // pageLink.push({icon: 'star',title: '关注清单',text: '您可以查看收藏至关注清单的产品', linkName: 'favorite', color: '#FF3B30'});
      // pageLink.push({icon: 'notification',title: '通知中心',text: '您可以在这里查看最新通知', linkName: 'newsCenter', color: '#4CD964'});
      // pageLink.push({icon: 'chart',title: '测量记录',text: '您可以在这里查看您的测量记录', linkName: 'customHistory', color: '#000000'});
      // pageLink.push({icon: 'coupon',title: '我的优惠券',text: '您可以在这里查看可以使用的优惠券', linkName: 'coupon', color: '#FFCC00'});
      // pageLink.push({icon: 'link',title: '专属推荐连结',text: '您的专属推荐连结', linkName: 'recommend', color: '#007AFF'});
      // this.pageItem = pageLink;

      // 放user已存在的资料
      const { user } = get('userInfo');
      console.log('userInfo',user);
      this.level = user.grade;
      this.exp = user.point || 0;
      this.username = user.name;
    },
    computed: {
      getMobileExp() {
        const exp = this.exp;
        let rangeIndex = '';
        this.expRange.forEach((item,index) => {
          if(exp>=item.start && exp<item.end) {
            rangeIndex = index;
          }
        })
        return (exp-this.expRange[rangeIndex].start)/10000;
      },
      getLevelNotice() {
        const exp = this.exp;
        const nextLevel = this.expRange[this.level];
        let levelNotice = '';
        if(nextLevel) {
          levelNotice = `${this.$t('user_center.level_text1')}${nextLevel.start-parseInt(this.exp)}${this.$t('user_center.level_text2')}${nextLevel.title}${this.$t('user_center.level_text3')}`;
        }else{
          levelNotice = this.$t('user_center.level_max');
        }
        return levelNotice;
      }
    }
  }
</script>

<style lang="less" scoped>
.user-center-page {
  @media (max-width: 992px) {
    .page-container {
      padding-top: 0;
    }
    .page-right {
      padding-left: 0;
      padding-right: 0;
    }    
  }
  .welcome-info {
    background: #F0F0F0;
    text-align: center;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.4rem 0;
    .level-text {
      border: 1px solid #FF5214;
      color: #FF5214;
      margin-left: 20px;
      border-radius: 3px;
      padding: 2px 6px;
      display: block;
      font-size: 1rem;
    }
  }
  .level-info {
    .level-icons {
      display: flex;
      .level-icon {
        flex: 1;
        margin-left: 20px;
        padding: 80px 0;
        position: relative;
        &:nth-child(1) {
          margin-left: 0;
        }
        .level1 {
          background: url('./images/level1.png');
        }
        .level2 {
          background: url('./images/level2.png');
        }
        .level3 {
          background: url('./images/level3.png');
        }
        .level4 {
          background: url('./images/level4.png');
        }
        .level5 {
          background: url('./images/level5.png');
        }
        .icon-img {
          width: 100%;
          padding-top: 100%;
          background-size: cover;
        }
        .active-text {
          position: absolute;
          color: #FF5214;
          font-weight: 400;
          left: 50%;
          transform: translateX(-50%);
          top: 20px;
          display: none;
          &::after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 12px 8px 0 8px;
            border-color: #FF5214 transparent transparent transparent;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .next-level-notice {
          position: absolute;
          font-size: 0.6rem;
          width: 150%;
          text-align: center;
          left: 50%;
          transform: translateX(-50%);
          bottom: 50px;
          display: none;
        }
        &.active {
          .active-text {
            display: block;
          }
          .next-level-notice {
            display: block;
          }
          .level1 {
            background: url('./images/level1-active.png');
          }
          .level2 {
            background: url('./images/level2-active.png');
          }
          .level3 {
            background: url('./images/level3-active.png');
          }
          .level4 {
            background: url('./images/level4-active.png');
          }
          .level5 {
            background: url('./images/level5-active.png');
          }
          .icon-img {
            background-size: cover;
          }
        }
      }
    }

  }
  .level-info-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px 20px;
    padding-top: 30px;
    background-image: url('./images/bg_01.png');
    background-size: 105% 105%;
    background-position: center;
    .level-icon {
      width: 100px;
      height: 100px;
      background-size: cover;
      margin-bottom: 20px;
      &.level1 {
        background-image: url('./images/level1-active.png');
      }
      &.level2 {
        background-image: url('./images/level2-active.png');
      }
      &.level3 {
        background-image: url('./images/level3-active.png');
      }
      &.level4 {
        background-image: url('./images/level4-active.png');
      }
      &.level5 {
        background-image: url('./images/level5-active.png');
      }
    }
    .user-name {
      margin-bottom: 10px;
      color: white;
      .big {
        font-size: 1.4rem;
      }
    }
    .level-text {
      display: flex;
      line-height: 24px;
      background: #EC4F00;
      color: white;
      padding: 2px 4px;
      border-radius: 3px;
      
      /deep/ .cloud-icon {
        fill: white;
      }
    }
    .level-exp-mobile {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      padding-top: 50px;
      .circle {
        width: 14px;
        height: 14px;
        position: relative;
        // background: black;
        border-radius: 50%;
        &::before {
          content: '';
          border: 2px solid white;
          position: absolute;
          width: 100%;
          height: 100%;
          top: -2px;
          left: -2px;
          border-radius: 50%;
        }
        &::after {
          content: '';
          position: absolute;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          top: 2px;
          left: 2px;
          border-radius: 50%;
          background: white;
        }
        &.active {
          background: #EC4F00;
          &::after {
            content: '';
            background: #EC4F00;
          }
        }
        .circle-text {
          color: white;
          position: absolute;
          width: 40px;
          right: 0;
          top: -30px;
          font-weight: 400;
          transform: scale(.8) translateX(20%);
        }
      }
      .line {
        flex: 1;
        background: white;
        height: 6px;
        position: relative;
        .line-schedule {
          width: 100%;
          position: absolute;
          height: 3px;
          top: 1.5px;
          z-index: 1;
          .schedule-content {
            background: #EC4F00;
            width: 100%;
            height: 100%;
            transform-origin: 0 50%;
          }
          .cloud-block {
            position: absolute;
            top: 0;
            // right: 0;
            transform: translate(-50%,-120%);
            padding-bottom: 6px;
            .cloud-text {
              color: white;
              font-size: 0.8rem;
            }
            .cloud-icon {
              fill: white;
              margin: auto;
              width: 16px;
              height: 16px;
            }
            &::after {
              content: '';
              position: absolute;
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 3px 2px 0 2px;
              border-color: white transparent transparent transparent;
              bottom: 2px;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }
    }
  }
  .level-exp {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 100px 0;
    .circle {
      background: #fff;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      &::after {
        content: '';
        border: 2px solid #D1D1D1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
        border-radius: 50%;
        box-sizing: border-box;
      }
      &::before {
        content: '';
        position: absolute;
        border-radius: 50%;
        box-sizing: border-box;
        width: calc(100% - 6px);
        height: calc(100% - 6px);
        top: 3px;
        left: 3px;
        background: #D1D1D1;
      }
      &.active {
        &::after {
          border: 2px solid #FF5214;
        }
        &::before {
          background: #FF5214;
        }
      }
      .level-text {
        position: absolute;
        bottom: -1.2rem;
        left: 50%;
        transform: translateX(-50%) scale(.8);
        font-size: 0.5rem;
      }
    }
    .line1 {
      position: absolute;
      background: #D1D1D1;
      width: 100%;
      height: 2px;
      top: calc(50% - 1px);
      z-index: -1;
    }
    .line2 {
      position: absolute;
      // background: #FF5214;
      width: calc(100% - 16px);
      height: 2px;
      top: calc(50% - 1px);
      left: 8px;
      z-index: -1;
      .line-content {
        background: #FF5214;
        width: 100%;
        height: 100%;
        transform-origin: 0 50%;
      }
      .cloud-block {
        position: absolute;
        top: 0;
        // right: 0;
        transform: translate(-50%,-120%);
        padding-bottom: 6px;
        .cloud-text {
          color: #FF5214;
          font-size: 0.8rem;
        }
        .cloud-icon {
          fill: #FF5214;
          margin: auto;
        }
        &::after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 4.5px 3px 0 3px;
          border-color: #FF5214 transparent transparent transparent;
          bottom: 2px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .page-link {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .link-item{
      flex: 0 0 calc(20% - 20px);
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #E6E6E6;
      cursor: pointer;
      margin-right: 25px;
      margin-bottom: 25px;
      padding: 25px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:nth-child(5n) {
        margin-right: 0;
      }
      /deep/ .cloud-icon {
        fill: #FF5214;
        width: 44px;
        height: 44px;
        margin-bottom: 14px;
      }
      .title {
        margin-bottom: 10px;
        font-weight: 400;
        text-align: center;
      }
      .text {
        line-height: 1.5rem;
      }
    }
    @media (max-width: 992px) {
      flex-direction: column;
      .link-item{
        flex-direction: row;
        margin-right: 0;
        margin-bottom: 0;
        box-shadow: unset;
        border: unset;
        align-items: center;
        padding: 10px 20px;
        position: relative;
        /deep/ .cloud-icon {
          fill: white;
          width: 28px;
          height: 28px;
          padding: 5px;
          border-radius: 4px;
          margin-bottom: 0;
          margin-right: 10px;
        }
        .title {
          margin-bottom: 10px;
          font-weight: 400;
          font-size: 1.2rem;
          margin-bottom: 0;
        }
        .text {
          display: none;
        }
        &::after {
          content: '';
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:none;%7D.b%7Bfill:%23C7C7CC;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M24,0H0V24H24Z'/%3E%3Cpath class='b' d='M8,7.351,9.351,6l5.75,5.75L9.351,17.5,8,16.149l4.389-4.4Z' transform='translate(0.75 0.25)'/%3E%3C/svg%3E");
          width: 32px;
          height: 32px;
          position: absolute;
          right: 10px;
        }
      }
    }
    @media (min-width: 992px) {
      .link-item{
        /deep/ .cloud-icon {
          background: white !important;
        }
      }
    }
  }
}
</style>